var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sidebar-menu',{attrs:{"menu":_vm.menu,"collapsed":_vm.collapsed,"theme":"white-theme","width":"224px"},on:{"toggle-collapse":_vm.onToggleCollapse}})
}
var staticRenderFns = []

export { render, staticRenderFns }